import { FormControl, Grid, InputLabel } from '@mui/material';
import { StyledOutlinedInput } from 'components/atoms';
import {
  InputFieldProps,
  withGridItemCSS,
  withWrapperCSS,
} from 'components/organisms/forms/form-builder/types';
import { noop } from 'lodash';
import React, { ChangeEvent, FC, useState } from 'react';

export const InputFieldFloatingLabel: FC<
  InputFieldProps<string> & withGridItemCSS & withWrapperCSS
> = ({
  disabled = false,
  error = false,
  fieldKey,
  gridItemCss,
  initValue = '',
  isPassword = false,
  label = '',
  onChange = noop,
  labelCss,
  type = 'text',
  required = false,
  wrapperCss,
  xs = 12,
}) => {
  const [value, setValue] = useState(initValue);

  function onFieldChange({ target: { value: newValue } }: ChangeEvent<HTMLInputElement>) {
    onChange(newValue, fieldKey);
    setValue(newValue);
  }
  return (
    <Grid item xs={xs} style={gridItemCss}>
      <FormControl error={!!error} required={required} style={wrapperCss}>
        <StyledOutlinedInput
          disabled={disabled}
          error={!!error}
          value={value}
          onChange={onFieldChange}
          placeholder={' '}
          required={required}
          type={type}
          id={fieldKey}
          name={fieldKey}
          autoComplete={isPassword ? 'password' : undefined}
        />
        <InputLabel style={labelCss}>{label}</InputLabel>
        {/* <FormErrorMessage>{error}</FormErrorMessage> */}
      </FormControl>
    </Grid>
  );
};
